<template>
    <div class="modal-card" style="width: 100%">
        <header class="modal-card-head">
            <p class="modal-card-title">
                Modifica formular <strong>{{ currentFormId }}</strong>
            </p>
            <button type="button" class="delete" @click="$emit('close')" />
        </header>
        <section class="modal-card-body">
            <div class="main-container formular-230 has-shadow" :class="{ 'on-mobile-right': screenWidth <= 1023 }">
                <ValidationObserver ref="observer" v-slot="{}">
                    <div class="has-text-left">
                        <div
                            class="title has-text-weight-semibold is-size-5 has-text-weight-bold is-flex is-align-content-center is-align-items-center"
                        >
                            <div>
                                <b-icon
                                    class="mr-3 has-text-grey-lighter"
                                    icon="account-details-outline"
                                    size="is-medium"
                                >
                                </b-icon>
                            </div>
                            <div>Date contribuabil</div>
                        </div>
                        <div class="columns">
                            <div class="column">
                                <ValidationProvider
                                    rules="required|alpha_spaces_minus|min:2|max:45"
                                    name="nume"
                                    v-slot="{ errors, valid }"
                                >
                                    <b-field :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                                        <b-input
                                            size="is-medium"
                                            placeholder="Nume"
                                            v-model.trim="nume"
                                            minlength="1"
                                        ></b-input>
                                    </b-field>
                                </ValidationProvider>
                            </div>
                            <div class="column">
                                <ValidationProvider
                                    rules="required|alpha_spaces_minus|min:2|max:45"
                                    name="prenume"
                                    v-slot="{ errors, valid }"
                                >
                                    <b-field :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                                        <b-input
                                            size="is-medium"
                                            placeholder="Prenume"
                                            v-model.trim="prenume"
                                            minlength="1"
                                        ></b-input>
                                    </b-field>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column">
                                <ValidationProvider
                                    rules="max:1|alpha"
                                    name="initiala"
                                    v-slot="{ errors, valid, changed }"
                                >
                                    <b-field
                                        :type="{ 'is-danger': errors[0], 'is-success': valid && changed }"
                                        :message="errors"
                                    >
                                        <b-input
                                            size="is-medium"
                                            placeholder="Initiala tata"
                                            v-model.trim="initiala"
                                            minlength="1"
                                        ></b-input>
                                    </b-field>
                                </ValidationProvider>
                            </div>
                            <div class="column">
                                <ValidationProvider
                                    rules="required|cnplength:13|cnpinteger|cnpformat"
                                    name="CNP"
                                    vid="cnp"
                                    v-slot="{ errors, valid }"
                                >
                                    <b-field :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                                        <b-input
                                            disabled
                                            size="is-medium"
                                            class="is-fulllength"
                                            placeholder="CNP"
                                            v-model.trim="cnp"
                                            minlength="1"
                                        ></b-input>
                                    </b-field>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column">
                                <ValidationProvider rules="email" name="email" v-slot="{ errors, valid, changed }">
                                    <b-field
                                        :type="{
                                            'is-danger': errors[0],
                                            'is-success': valid && changed,
                                        }"
                                        :message="errors"
                                    >
                                        <b-input
                                            size="is-medium"
                                            placeholder="Email"
                                            type="email"
                                            v-model.trim="email"
                                            minlength="1"
                                        ></b-input>
                                    </b-field>
                                </ValidationProvider>
                            </div>
                            <div class="column">
                                <ValidationProvider
                                    rules="required|phoneformat|phonedigits:10"
                                    name="telefon"
                                    vid="telefon"
                                    v-slot="{ errors, valid }"
                                >
                                    <b-field :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                                        <b-input
                                            size="is-medium"
                                            placeholder="Telefon"
                                            v-model.trim="telefon"
                                            minlength="1"
                                        ></b-input>
                                    </b-field>
                                </ValidationProvider>
                            </div>
                        </div>

                        <div
                            class="subtitle has-text-weight-semibold is-size-5 has-text-weight-bold is-flex is-align-content-center is-align-items-center"
                        >
                            <div>
                                <b-icon
                                    class="mr-3 has-text-grey-lighter"
                                    icon="map-marker-radius-outline"
                                    size="is-medium"
                                >
                                </b-icon>
                            </div>
                            <div>Adresa</div>
                        </div>
                        <div class="columns">
                            <div class="column">
                                <ValidationProvider
                                    vid="county"
                                    rules="required"
                                    name="judet"
                                    v-slot="{ errors, valid }"
                                >
                                    <b-field :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                                        <b-select
                                            :loading="isCountyLoading"
                                            @input="onCountySelect"
                                            size="is-medium"
                                            placeholder="Judet"
                                            v-model="judet"
                                            expanded
                                        >
                                            <option class="placeholder-option" value="" selected>Alege judetul</option>
                                            <option v-for="judet in judete" :key="judet.id" :value="judet.name">
                                                {{ judet.name }}
                                            </option>
                                        </b-select>
                                    </b-field>
                                </ValidationProvider>
                            </div>
                            <div class="column" v-if="judet != null && judet !== ''">
                                <ValidationProvider
                                    vid="city"
                                    rules="required"
                                    name="localitate"
                                    v-slot="{ errors, valid }"
                                >
                                    <b-field :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                                        <b-select
                                            :loading="isCityLoading"
                                            placeholder="Localitate"
                                            size="is-medium"
                                            v-model="localitate"
                                            :disabled="judet == null || judet === ''"
                                            expanded
                                        >
                                            <option class="placeholder-option" value="" selected>
                                                Alege {{ judet === 'Bucuresti' ? 'sectorul' : 'localitatea' }}
                                            </option>
                                            <option
                                                v-for="localitate in localitati"
                                                :value="localitate.name"
                                                :key="localitate.id"
                                            >
                                                {{ localitate.name }}
                                            </option>
                                        </b-select>
                                    </b-field>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column">
                                <ValidationProvider rules="required|max:45" name="strada" v-slot="{ errors, valid }">
                                    <b-field :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                                        <b-input
                                            size="is-medium"
                                            placeholder="Strada"
                                            v-model.trim="strada"
                                            minlength="1"
                                        ></b-input>
                                    </b-field>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column">
                                <ValidationProvider rules="max:10" name="numar" v-slot="{ errors, valid, changed }">
                                    <b-field
                                        :type="{
                                            'is-danger': errors[0],
                                            'is-success': valid && changed,
                                        }"
                                        :message="errors"
                                    >
                                        <b-input
                                            size="is-medium"
                                            placeholder="Numar"
                                            v-model.trim="numar"
                                            minlength="1"
                                        ></b-input>
                                    </b-field>
                                </ValidationProvider>
                            </div>
                            <div class="column">
                                <ValidationProvider rules="max:8" name="bloc" v-slot="{ errors, valid, changed }">
                                    <b-field
                                        :type="{
                                            'is-danger': errors[0],
                                            'is-success': valid && changed,
                                        }"
                                        :message="errors"
                                    >
                                        <b-input
                                            size="is-medium"
                                            placeholder="Bloc"
                                            v-model.trim="bloc"
                                            minlength="1"
                                        ></b-input>
                                    </b-field>
                                </ValidationProvider>
                            </div>
                            <div class="column">
                                <ValidationProvider rules="max:8" name="scara" v-slot="{ errors, valid, changed }">
                                    <b-field
                                        :type="{
                                            'is-danger': errors[0],
                                            'is-success': valid && changed,
                                        }"
                                        :message="errors"
                                    >
                                        <b-input
                                            size="is-medium"
                                            placeholder="Scara"
                                            v-model.trim="scara"
                                            minlength="1"
                                        ></b-input>
                                    </b-field>
                                </ValidationProvider>
                            </div>
                            <div class="column">
                                <ValidationProvider rules="max:5" name="etaj" v-slot="{ errors, valid, changed }">
                                    <b-field
                                        :type="{
                                            'is-danger': errors[0],
                                            'is-success': valid && changed,
                                        }"
                                        :message="errors"
                                    >
                                        <b-input
                                            size="is-medium"
                                            placeholder="Etaj"
                                            v-model.trim="etaj"
                                            minlength="1"
                                        ></b-input>
                                    </b-field>
                                </ValidationProvider>
                            </div>
                            <div class="column">
                                <ValidationProvider rules="max:5" name="apartament" v-slot="{ errors, valid, changed }">
                                    <b-field
                                        :type="{
                                            'is-danger': errors[0],
                                            'is-success': valid && changed,
                                        }"
                                        :message="errors"
                                    >
                                        <b-input
                                            size="is-medium"
                                            placeholder="Apartament"
                                            v-model.trim="apartament"
                                            minlength="1"
                                        ></b-input>
                                    </b-field>
                                </ValidationProvider>
                            </div>
                        </div>
                        <hr />
                        <div class="columns is-desktop is-align-content-center is-align-items-center">
                            <div class="column is-one-fifth">
                                <div
                                    class="subtitle has-text-weight-semibold is-size-5 has-text-weight-bold is-flex is-align-content-center is-align-items-center"
                                >
                                    <div>
                                        <b-icon
                                            class="mr-3 has-text-grey-lighter"
                                            icon="calendar-month-outline"
                                            size="is-medium"
                                        >
                                        </b-icon>
                                    </div>
                                    <div>Perioada</div>
                                </div>
                            </div>
                            <div class="column">
                                <ValidationProvider rules="required" name="perioada" v-slot="{ errors, valid }">
                                    <b-field :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                                        <b-radio-button
                                            class="period-form"
                                            type="is-success"
                                            size="is-medium"
                                            v-model="perioada"
                                            name="perioada"
                                            :native-value="1"
                                        >
                                            1 an
                                        </b-radio-button>
                                        <b-radio-button
                                            :disabled="oneYearPeriod"
                                            class="period-form"
                                            type="is-success"
                                            size="is-medium"
                                            v-model="perioada"
                                            name="perioada"
                                            :native-value="2"
                                            checked
                                        >
                                            2 ani
                                        </b-radio-button>
                                    </b-field>
                                </ValidationProvider>
                            </div>
                        </div>
                    </div>
                </ValidationObserver>
            </div>
        </section>
        <footer class="modal-card-foot">
            <b-button type="is-info" @click="$emit('close')">Inchide</b-button>
            <b-button type="is-success" @click="saveFormEdit">Salveaza</b-button>
        </footer>
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';

import * as toast from '@/utils/toast';
import * as dialogs from '@/utils/dialog';
import { sync, call, get } from 'vuex-pathify';
import { mapGetters } from 'vuex';
import { _base64ToArrayBuffer } from '@/utils/functions';

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data: () => ({
        isCityLoading: true,
        isCountyLoading: true,
        screenWidth: 1920,
        originalFormData: {},
    }),
    name: 'FormEditor',
    methods: {
        async approve() {
            this.isApproveLoading = true;
            try {
                await this.$store.dispatch('admin/ApproveForm', this.currentManualFormId);
                toast.success('Formular aprobat');
                this.$emit('next');
            } catch (err) {
                toast.error('Eroare la aprobarea formularului');
            } finally {
                this.isApproveLoading = false;
            }
        },
        async getFormData() {
            this.isLoading = true;
            try {
                await this.$store.dispatch('admin/GetFormData');
            } catch (err) {
                toast.error('Eroare la preluarea datelor formularului');
            } finally {
                this.isLoading = false;
            }
        },
        async onCountySelect(countyName, recursive = false) {
            const countyObj = this.judete.find((judet) => judet.name === countyName);
            if (countyObj == null) {
                return toast.error('Judet invalid');
            }
            this.isCityLoading = true;
            try {
                await this.$store.dispatch('app/GetCitiesByCountyId', countyObj.id);
                // this.$refs.observer.refs.localitate.setFlags({ changed: true, touched: true, untouched: false });
            } catch (err) {
                console.log(err);
                this.$reportToSentry(err, {
                    extra: {
                        fn: 'GetCitiesByCountyId',
                        params: {
                            event: 'GetCitiesByCountyId',
                            countyObj,
                            countyName,
                            err,
                        },
                    },
                });
                toast.error('Eroare la preluarea localitatilor');
            } finally {
                this.isCityLoading = false;
            }
        },
        async setCountyAndCities() {
            return new Promise((resolve, reject) => {
                setTimeout(async () => {
                    try {
                        await this.onCountySelect(this.judet);
                        return resolve();
                    } catch (err) {
                        return reject(err);
                    }
                }, 500);
            });
        },

        async saveFormEdit() {
            const { result } = await dialogs.confirm('Atentie', `Salvez modificarile?`, 'Confirm', 'is-warning');
            if (!result) return false;
            console.log(this.originalFormData);
            try {
                await this.$store.dispatch('admin/SaveFormEdit');
				toast.success('Modificari salvate!');
				return this.$emit('close');
            } catch (err) {
                console.log(err);
                this.$reportToSentry(err, {
                    extra: {
                        fn: 'saveFormEdit',
                        params: {
                            event: 'saveFormEdit',
                            form: this.form,
                            err,
                        },
                    },
                });
                toast.error('Eroare la salvarea modificarilor');
            }
        },
    },
    computed: {
        ...mapGetters({
            currentFormId: 'admin/currentFormEditId',
            oneYearPeriod: 'formular/oneYearPeriod',
        }),
        ...sync('admin/formular230@formEdit.formData', {
            cnp: 'cnp',
            email: 'email',
            initiala: 'initiala',
            nume: 'nume',
            perioada: 'perioada',
            prenume: 'prenume',
            telefon: 'telefon',
        }),
        ...sync('admin/formular230@formEdit.formData.forms_address', {
            apartament: 'apartament',
            bloc: 'bloc',
            etaj: 'etaj',
            judet: 'judet',
            localitate: 'localitate',
            numar: 'numar',
            scara: 'scara',
            strada: 'strada',
        }),
        localitati: get('app/cities'),
        judete: get('app/counties'),
        form: get('admin/formular230@formEdit.formData'),
    },
    watch: {
        currentFormId() {
            return this.getFormData();
        },
        form() {
            this.originalFormData = Object.assign({}, JSON.parse(JSON.stringify(this.form)));
        },
    },
    async created() {
        this.isCountyLoading = true;
        try {
            await this.$store.dispatch('app/GetCounties');
        } catch (err) {
            this.$reportToSentry(err, {
                extra: {
                    fn: 'FamilyGetCounties',
                    params: {
                        event: 'FamilyGetCounties',

                        err,
                    },
                },
            });
            toast.error('Eroare la preluarea judetelor', 6000, 'is-top');
        } finally {
            this.isCountyLoading = false;
        }
        await this.getFormData();
        await this.setCountyAndCities();
    },
};
</script>

<style lang="scss" scoped>
.main-container {
    padding: 0;
    position: relative;
}

.font-14 {
    font-size: 0.9rem;
    font-weight: 500;
}

.period-form {
    &:not(:last-child) {
        margin-right: 20px !important;
    }

    .radio {
        border-radius: 10px !important;
    }
}

.is-size-4 {
    font-size: 1.5rem !important;
}

hr {
    background-color: #dbdbdb;
}

.info {
    display: table;
    margin: 0 auto;
    margin-top: 50px;
    padding: 40px;
    opacity: 0.9;

    .info-text {
        font-size: 0.9rem;
        padding-top: 5px;
    }
}

.on-mobile-left {
    border-radius: 6px 6px 0px 0px;
}
.on-mobile-right .box {
    border-radius: 0px 0px 6px 6px;
}

.form-title {
    font-size: 1.8rem;
}

.text-with-border {
    border: 1px solid;
    background-color: white;
    border-color: #dbdbdb;
    border-radius: 4px;
    color: #363636;
    height: 3.5em;
    font-size: 0.9rem;
    line-height: 1.5;
    padding-bottom: calc(0.5em - 1px);
    padding-left: calc(0.75em - 1px);
    padding-right: calc(0.75em - 1px);
    padding-top: calc(0.5em - 1px);
}

::v-deep .on-mobile input:disabled {
    -webkit-appearance: none;
    color: #7a7a7a !important;
    background-color: #f5f5f5bf;
    -webkit-text-fill-color: #7a7a7a !important;
    -webkit-opacity: 1 !important;
    opacity: 1 !important;
}

.overlay-invalid {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    align-items: center;
    display: flex;
    justify-content: center;
    overflow: hidden;
    z-index: 999;

    .ov-background {
        bottom: 0;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        background: #7f7f7f;
        background: rgb(255 255 255 / 78%);
    }

    .ov-text {
        padding: 50px;
        background-color: #296c9e;
        z-index: 120;
        color: #fff;
        border-radius: 6px;
        position: fixed;
        top: 20em;
        box-shadow: 6px 6px 5px rgb(0 0 0 / 33%);
    }
}

::v-deep .is-radio .radio {
    color: #363636 !important;
}

.is-fixed {
    position: -webkit-sticky; /* Safari */
    position: sticky;
    top: 0;
}

.formular-230 {
    height: 3.2em !important;
    font-size: 0.85rem !important;
}
</style>
